import React from 'react';
import { useTranslation } from 'next-i18next';
import { NAME } from '@app/marketing/constants';

// UI
import Headline from '@ui/components/Headline';
import Subtitle from '@ui/components/Subtitle';
import { ExclamationCircleIcon } from '@heroicons/react/24/outline';

// Types
export interface Props {}

const Error: React.FC<Props> = ({}) => {
    const { t } = useTranslation(NAME);

    return (
        <div data-cy="shared-error" className="text-center">
            <ExclamationCircleIcon className="mx-auto mb-10 h-24 w-24 text-yellow-500" />

            <Headline>{t('shared-funnel-error-title')}</Headline>
            <Subtitle>{t('shared-funnel-error-description')}</Subtitle>
        </div>
    );
};

export default Error;
